import React, { useContext, useEffect, useState } from "react";
import ModalHalloween from "./common/ModalHalloween";
import RangeSlider from "react-range-slider-input";
import { FaDollarSign, FaFileInvoice, FaLock, FaSearch, FaUniversity, FaUser } from "react-icons/fa";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { BLAUTHTOKEN, CURRENCY_CODE, deleteDataFromStore, setDataInStore, TEMPLATE_ID, } from "../utils/CookiesUtils";
import { callGetApi, callPutApi } from "../api/ApiCaller";
import { PLAYER_AVATAR_LIST_GET, PLAYER_CHANGE_PASSWORD_PUT, PLAYER_PROFILE_UPDATE_PUT, PLAYER_TEMPLATE_LIST_GET, GET_STATIC_DATA_GET, PLAYER_PROFILE_UPDATE_POST, GET_PLAYER_BALANCE_GET } from "../api/ApiConst";
import toast from "react-hot-toast";
import { STATUS } from "../utils/Constants";
import { isEmpty } from "../utils/TextUtils";
import { useBalance } from "../BalanceContext";
import { getCurrencySymbol } from '../utils/TextUtils';
import MobileProfile from "./common/MobileProfile";
import LanguageDropdown from "./common/LanguageDropdown";

const Dashboard = () => {
    const defaultObj = {
        newPassword: "",
        confirmPassword: "",
    }
    const { profileDetails, getPlayerDetails, walletBalance, getWalletBalance, hiddenBalance, setHiddenBalance } = useBalance();
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [showUpdateProfile, setShowUpdateProfile] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [showGameSettings, setShowGameSettings] = useState(false);
    const [showLeaderboard, setShowLeaderboard] = useState(false);
    const [templateList, setTemplateList] = useState(null);
    const [avatarList, setAvatarList] = useState(null);
    const [webCmsKey, setWebCmsKey] = useState(null)
    const [selectedAvatar, setSelectedAvatar] = useState({ label: profileDetails?.photoImageUrl, key: "" });
    const [changePassword, setChangePassword] = useState(defaultObj);
    const [showContentModal, setShowContentModal] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate();

    let sidebar = [
        {
            label: "Personal data",
            icon: <FaUser />,
            path: "/personal-data",
            isPending: true
        },
        {
            label: "Deposit",
            icon: <FaDollarSign />,
            path: "/deposit"
        },
        {
            label: "Withdraw",
            icon: <FaUniversity />,
            path: "/withdraw"
        },
        {
            label: "Account statement",
            icon: <FaFileInvoice />,
            path: "/account-statement"
        },
        {
            label: "Password and security",
            icon: <FaLock />,
            path: "/password-security"
        }
    ]

    // UPDATED: Handle navigation based on game type
    const handleNavigate = (recordId, gameType) => {
        setDataInStore(TEMPLATE_ID, recordId);
        if (gameType === "Halloween_Bomba_25") {
            navigate("/halloween-bomba");
        } else {
            navigate("/gameplay");
        }
    }

    const handleLogOut = () => {
        deleteDataFromStore(BLAUTHTOKEN);
        deleteDataFromStore(CURRENCY_CODE);
        navigate("/login");
    }

    useEffect(() => {
        getPlayerDetails();
        getTemplatePlayerList();
        getWalletBalance()
    }, []);

    const getTemplatePlayerList = () => {
        callGetApi(PLAYER_TEMPLATE_LIST_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                let res = response.responsePacket;
                setTemplateList(res);
            } else {
                toast.error(response.message);
            }
        },
            (e) => {
                toast.error(e.message);
            }
        );
    }

    const handleProfileDetails = (e) => {
        setShowProfileModal(true)
    }

    const getAvatarList = () => {
        setShowUpdateProfile(true);
        callGetApi(PLAYER_AVATAR_LIST_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                const res = response.responsePacket.map((item) => ({
                    key: item.key,
                    label: item.label,
                }))
                setAvatarList(res);
            } else {
                toast.error(response.message);
            }
        },
            (e) => {
                toast.error(e.message);
            }
        );
    }

    const handleAvatar = (avatar) => {
        const payload = {
            fullName: "",
            photoImageUrl: avatar.label
        };
        callPutApi(PLAYER_PROFILE_UPDATE_PUT, payload, {}, (response) => {
            if (response.errorCode === 0) {
                getPlayerDetails();
                setShowUpdateProfile(false);
                toast.success(response.message);
            }

        },
            (e) => {
                toast.error(e.message);
            }
        );
    };

    const handleUpdatePassword = () => {
        if (isEmpty(changePassword.newPassword)) {
            toast.error("New password must not be empty.");
            return;
        }
        if (isEmpty(changePassword.confirmPassword)) {
            toast.error("Confirm password must not be empty.");
            return;
        }
        if (changePassword.newPassword !== changePassword.confirmPassword) {
            toast.error("New password and confirm password do not match.");
            return;
        }
        if (changePassword.newPassword.length < 8) {
            toast.error("New password should contain at least 8 characters.");
            return;
        }
        const payload = {
            newPassword: changePassword.newPassword,
            confirmPassword: changePassword.confirmPassword,
        };

        callPutApi(PLAYER_CHANGE_PASSWORD_PUT, payload, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setChangePassword(defaultObj);
                toast.success(response.message, { id: "Toast" });
                setShowChangePasswordModal(false);
                setTimeout(() => {
                    deleteDataFromStore(BLAUTHTOKEN);
                    deleteDataFromStore(CURRENCY_CODE);
                    navigate("/login");
                }, 2000);
            } else {
                toast.error(response.message);
            }
        })
    }

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setChangePassword((prev) => ({ ...prev, [name]: value }));
    }

    const handleWebCms = (type) => {
        callGetApi(GET_STATIC_DATA_GET.replaceAll("{websiteCmsKey}", type), {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                const res = response.responsePacket;
                setWebCmsKey(res);
                setShowContentModal(true);
                setModalTitle(type === 'PrivacyPolicy' ? 'Privacy Policy' : 'Terms & Conditions');
            } else {
                toast.error(response.message);
            }
        },
            (e) => {
                toast.error(e.message);
            }
        );
    }

    return (
        <>
            <div className="lobby-wrapper">
                <header className="lobby-header">
                    <div className="header-top-row">
                        <div className="header-left" onClick={() => navigate("/")}>
                            <img
                                src="assets/img/logo.png"
                                alt="logo"
                                className="img-fluid"
                                style={{ width: "108px" }}
                            />
                        </div>
                        <div className="header-right">
                            <button onClick={() => navigate("/deposit")} className="deposit-btn">Deposit</button>
                            <div className="balance-display">
                                <span className="balance-amount"> {hiddenBalance ? "••••" : getCurrencySymbol(profileDetails?.currencyCode) + " " + walletBalance?.toFixed(2)} <FaUser onClick={() => setShowProfileModal(true)} className="user-icon" /></span>
                            </div>
                        </div>
                    </div>
                    <div className="header-bottom-row">
                        <select className="slot-btn active">
                            <option>Slot</option>
                            <option>Bingo</option>
                            <option>Mesa</option>
                        </select>
                        <div className="search-bar">
                            <FaSearch className="search-icon" />
                            <input type="text" placeholder="Search" />
                        </div>
                        <div className="d-flex gap-2">
                            <a href="#" onClick={() => handleWebCms('TermsAndConditions')} className="rules-link">Rules</a>
                            <LanguageDropdown />
                        </div>
                    </div>
                </header>
                <div className="lobby-main-content">
                    <aside className="lobby-sidebar">
                        <ul>
                            {sidebar.map((item, index) => (
                                <Link key={index} className={`${item.path === window.location.pathname ? "active" : ""}`} to={item.path}>
                                    <span>{item.icon}</span>
                                    {item.label}
                                </Link>
                            ))}
                        </ul>
                    </aside>
                    <main className="lobby-games-area">
                        <Outlet />
                    </main>
                </div>
            </div>

            {/* Commented out game grid - keeping original for reference */}
            {/* <div className="main-content">
                <div className="container-xxl container-xl container-lg container-fluid">
                    <div className="row justify-content-center">
                        {templateList?.map((item, index) => (
                            <div key={index} className="col-4 text-center">
                                <div className="h-100 position-relative cursor-pointer" onClick={() => handleNavigate(item.recordId, item.slotGameType)}>
                                    <img
                                        className="frame-mb img-fluid"
                                        src="assets/img/halloween-frame.png"
                                        alt="frame"
                                    />
                                    <div className="pumpkin position-absolute d-flex align-items-center justify-content-center">
                                        <div className="d-block">
                                            <img
                                                className="img-fluid pumpkin-width"
                                                src="assets/img/pumpkin.png"
                                                alt="pumpkin"
                                            />
                                            <h6 className="h3 m-0 text-white fw-bold">{item.title}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div> */}

            {/* All modals remain exactly the same */}
            <ModalHalloween
                show={showProfileModal}
                toggleModel={() => setShowProfileModal(false)}
            >
                <div className="modal-dialog m-0 profile-width rounded-4 overflow-hidden">
                    <div className="modal-content custom-modal-content">
                        <div className="modal-body text-center p-0">
                            <MobileProfile onClose={() => setShowProfileModal(false)} />
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween
                show={showUpdateProfile}
                toggleModel={() => setShowUpdateProfile(false)}
            >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content custom-modal-content">
                        <div className="modal-header position-relative">
                            <span
                                className="btn-close"
                                onClick={() => setShowUpdateProfile(false)}
                            />
                            <h6 className="m-0 fs-5">Update Profile</h6>
                        </div>
                        <div className="modal-body text-center ">
                            <div className="row">
                                <div className="col-lg-4 col-md-5 col-12">
                                    <div className="light-card d-flex align-items-center justify-content-center p-2 pb-3 h-100">
                                        <div className="d-block">
                                            <div className="d-flex align-items-center justify-content-center">
                                                <div className="profile-edit-outer position-relative">
                                                    <img
                                                        src={selectedAvatar.label === "" ? "/assets/images/001/user.png" : selectedAvatar.label}
                                                        alt="user"
                                                        className="img-fluid"
                                                    />
                                                    <div
                                                        onClick={() => setShowUpdateProfile(true)}
                                                        className="cursor-pointer edit-btn d-flex align-items-center justify-content-center position-absolute"
                                                    >
                                                        <i
                                                            className="fa-solid fa-camera"
                                                            style={{ color: "#9B0808" }}
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center mt-3">
                                                <button className="custom-btn w-150 d-flex align-items-center justify-content-center">
                                                    <span className="custom-outer w-150" >
                                                        <span className="custom-inner fs-6 text-blue d-flex align-items-center justify-content-center" onClick={() => handleAvatar(selectedAvatar)}>
                                                            UPDATE
                                                        </span>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 col-md-7 col-12 mt-lg-0 mt-md-0 mt-3">
                                    <div className="light-card p-2 h-100">
                                        <div className="w-100 d-flex align-items-center justify-content-center flex-wrap">
                                            {avatarList?.map((avatar, i) => (
                                                avatar?.label ? (
                                                    <div key={i} className={`profile-update-list position-relative ${selectedAvatar?.image === avatar.label ? "" : ""}`} onClick={() => setSelectedAvatar(avatar)}>
                                                        <img src={avatar.label} alt="user" className="img-fluid" />
                                                    </div>
                                                ) : null
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween
                show={showSettings}
                toggleModel={() => setShowSettings(false)}
            >
                <div className="modal-dialog setting-width m-0">
                    <div className="modal-content">
                        <div className="modal-header position-relative">
                            <span
                                className="btn-close"
                                onClick={() => setShowSettings(false)}
                            />
                            <h6 className="m-0 fs-5">Setting</h6>
                        </div>
                        <div className="modal-body text-center p-2">
                            <div className="dark-card p-2">
                                <div
                                    onClick={() => {
                                        setShowProfileModal(true);
                                        setShowSettings(false);
                                    }}
                                    className="cursor-pointer setting-list w-100 d-flex align-items-center justify-content-center"
                                >
                                    <span className="setting-inner w-100 py-1 px-2">Profile</span>
                                </div>
                                <div className="cursor-pointer mt-2 setting-list w-100 d-flex align-items-center justify-content-center" onClick={() => { }}>
                                    <span className="setting-inner w-100 py-1 px-2" onClick={() => handleWebCms('PrivacyPolicy')}>
                                        Privacy Policy
                                    </span>
                                </div>
                                <div className="cursor-pointer mt-2 setting-list w-100 d-flex align-items-center justify-content-center" onClick={() => { }}>
                                    <span className="setting-inner w-100 py-1 px-2 text-left" onClick={() => handleWebCms('TermsAndConditions')}>
                                        Terms & Conditions
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween
                show={showGameSettings}
                toggleModel={() => setShowGameSettings(false)}
            >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header position-relative">
                            <span
                                className="btn-close"
                                onClick={() => setShowGameSettings(false)}
                            />
                            <h6 className="m-0 fs-5">Game Setting</h6>
                        </div>
                        <div className="modal-body p-2">
                            <div className="dark-card p-2">
                                <p className="m-0 text-white">Sound</p>
                                <RangeSlider
                                    className="single-thumb mt-1"
                                    defaultValue={[0, 50]}
                                    thumbsDisabled={[true, false]}
                                    rangeSlideDisabled={true}
                                />
                                <p className="m-0 text-white mt-3">Music</p>
                                <RangeSlider
                                    className="single-thumb mt-1"
                                    defaultValue={[0, 70]}
                                    thumbsDisabled={[true, false]}
                                    rangeSlideDisabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween
                show={showLeaderboard}
                toggleModel={() => setShowLeaderboard(false)}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header position-relative">
                            <span
                                className="btn-close"
                                onClick={() => setShowLeaderboard(false)}
                            />
                            <h6 className="m-0 fs-5">Leaderboard</h6>
                        </div>
                        <div className="modal-body p-2">
                            <div className="dark-card p-2">
                                <div className="table-responsive table-leaderboard">
                                    <table className="table table-hover">
                                        <thead className="">
                                            <tr>
                                                <th>Rank</th>
                                                <th>Name</th>
                                                <th>Weekly Winnings</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-primary text-light">
                                            <tr>
                                                <td>1</td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <span className="leaderboard-user d-flex align-items-center justify-content-center me-2">
                                                            <img
                                                                className="img-fluid"
                                                                src="assets/img/user.png"
                                                                alt="user"
                                                            />
                                                        </span>
                                                        <p className="m-0 text-white">Player 1</p>
                                                    </div>
                                                </td>
                                                <td>$5,000</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <span className="leaderboard-user d-flex align-items-center justify-content-center me-2">
                                                            <img
                                                                className="img-fluid"
                                                                src="assets/img/user.png"
                                                                alt="user"
                                                            />
                                                        </span>
                                                        <p className="m-0 text-white">Player 2</p>
                                                    </div>
                                                </td>
                                                <td>$2,000</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <span className="leaderboard-user d-flex align-items-center justify-content-center me-2">
                                                            <img
                                                                className="img-fluid"
                                                                src="assets/img/user.png"
                                                                alt="user"
                                                            />
                                                        </span>
                                                        <p className="m-0 text-white">Player 3</p>
                                                    </div>
                                                </td>
                                                <td>$700</td>
                                            </tr>
                                            <tr>
                                                <td>4</td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <span className="leaderboard-user d-flex align-items-center justify-content-center me-2">
                                                            <img
                                                                className="img-fluid"
                                                                src="assets/img/user.png"
                                                                alt="user"
                                                            />
                                                        </span>
                                                        <p className="m-0 text-white">Player 4</p>
                                                    </div>
                                                </td>
                                                <td>$1,000</td>
                                            </tr>
                                            <tr>
                                                <td>5</td>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <span className="leaderboard-user d-flex align-items-center justify-content-center me-2">
                                                            <img
                                                                className="img-fluid"
                                                                src="assets/img/user.png"
                                                                alt="user"
                                                            />
                                                        </span>
                                                        <p className="m-0 text-white">Player 5</p>
                                                    </div>
                                                </td>
                                                <td>$1,500</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween
                show={showChangePasswordModal}
                toggleModel={() => setShowChangePasswordModal(false)}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content custom-modal-content">
                        <div className="modal-header position-relative">
                            <span
                                className="btn-close"
                                onClick={() => setShowChangePasswordModal(false)}
                            />
                            <h6 className="m-0 fs-5">CHANGE PASSWORD</h6>
                        </div>
                        <div className="modal-body text-center ">
                            <div className="">
                                <h6 className="m-0 text-white me-2 text-start fs-6 fw-light ">
                                    New Password:
                                </h6>
                                <div className="input-group">
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        className="form-control"
                                        placeholder="New Password"
                                        aria-label="Password"
                                        aria-describedby="Password"
                                        name="newPassword"
                                        value={changePassword.newPassword}
                                        onChange={(e) => handlePasswordChange(e)}
                                    />
                                    <span className="input-group-text password-toggle-icon" onClick={() => setShowNewPassword(!showNewPassword)}>
                                        <i className={showNewPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <div className="mt-lg-3 mt-md-3 mt-2">
                                <h6 className="m-0 text-white me-2 text-start fs-6 fw-light ">
                                    Confirm Password:
                                </h6>
                                <div className="input-group ">
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        className="form-control"
                                        placeholder="Confirm Password"
                                        aria-label="Password:"
                                        aria-describedby="Password:"
                                        name="confirmPassword"
                                        value={changePassword.confirmPassword}
                                        onChange={(e) => handlePasswordChange(e)}
                                    />
                                    <span className="input-group-text password-toggle-icon" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                        <i className={showConfirmPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <button
                                className="w-100 cursor-pointer btn-outer border-0 mt-lg-4 mt-md-3 mt-3 mb-lg-2 mb-md-2 mb-1"
                                onClick={handleUpdatePassword}
                            >
                                <span className="btn-inner">UPDATE PASSWORD</span>
                            </button>
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween show={showContentModal} toggleModel={() => setShowContentModal(false)}>
                <div className="modal-dialog tac-modal modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header dark-card" style={{border: 0, background: '#1a1a1a'}}>
                            <i className="fa fa-xmark custom-header-close-btn cursor-pointer" style={{color: '#ff8000'}} onClick={() => setShowContentModal(false)} />
                            <h6 className="m-0 fs-5" style={{color: '#ff8000'}}>{modalTitle}</h6>
                        </div>
                        <div className="modal-body text-start text-black bg-gray p-2" style={{background: '#2f2f2f'}}>
                            <div className="text-white">
                                <p dangerouslySetInnerHTML={{ __html: webCmsKey }} />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
        </>
    );
};

export default Dashboard;